import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { FAQ_ITEMS } from "../mock";
import Reveal from "./Reveal";

const FAQ = () => {
  return (
    <section id="faq" className="relative py-24 sm:py-28 border-t border-white/[0.05]">
      <div className="max-w-3xl mx-auto px-5 sm:px-6">
        <Reveal className="text-center">
          <h2 className="font-display font-800 text-white text-[2rem] sm:text-[2.9rem] leading-[1.05] tracking-tight">
            Questions before you automate.
          </h2>
        </Reveal>

        <Reveal delay={120} className="mt-12">
          <Accordion type="single" collapsible className="space-y-3">
            {FAQ_ITEMS.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="rounded-[18px] border border-white/[0.08] bg-gradient-to-b from-white/[0.03] to-white/[0.005] px-5 sm:px-6 data-[state=open]:border-[#d69b4e]/30 transition-colors"
              >
                <AccordionTrigger className="text-left text-white font-500 text-[1rem] sm:text-[1.05rem] py-5 hover:no-underline [&>svg]:text-[#d69b4e]">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#989286] text-[0.94rem] leading-relaxed pb-5 pr-4">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export default FAQ;
